import { FLEET_FILTER_INFO_MESSAGES } from '../product-list-page-constants';

import { FILTER_CATEGORY_CODES } from '../../../shared/constants/filters';

export function getFleetInfoMessage({ filters, products, selectedFilters }) {
  const isFleetPreferredSelected = selectedFilters.some(
    filter => filter.categoryCode === 'fleet-pref-boolean'
  );

  const fleetPreferredFilter = filters.find(
    item =>
      item.categoryCode === FILTER_CATEGORY_CODES.QUICK_FILTERS ||
      item.categoryCode === 'fleet-pref-boolean'
  );

  const fleetPrefValue = fleetPreferredFilter?.values?.find(
    item => item.categoryCode === 'fleet-pref-boolean'
  );
  const fleetPrefCount = fleetPrefValue?.count;

  const hasProducts = Boolean(products?.length);

  if (hasProducts) {
    if (fleetPrefCount === 0) {
      return FLEET_FILTER_INFO_MESSAGES.NO_FLEET_PREFERENCE_MATCH_INFO;
    } else if (!isFleetPreferredSelected && fleetPrefCount) {
      return FLEET_FILTER_INFO_MESSAGES.FLEET_FILTER_OFF_INFO;
    }
  }

  return null;
}
